import Vue from 'vue'
import { create } from '@/services/defaultServiceValues/defaultServiceValuesService'

const state = {
  defaultServiceSelectedTypes: [],

  showDefaultValuesForm: false,

  defaultServiceValuesFields: {
    service_contracts: [],
  },

  serviceContract: {
    index: null,
    contract_type: null,
    price: null,
    discount: null,
    square_meter_price: null,
    base_square_meters_price: null,
    host_tax: null,
    displacement_tax: null,
    square_meter_tax: null,
    furniture_tax: null,
    semi_furniture_tax: null,
    house_tax: null,
    trousseau_tax: null,
  },
}

const getters = {
  defaultServiceValuesFields: (state) => state.defaultServiceValuesFields,
  defaultServiceSelectedTypes: (state) => state.defaultServiceSelectedTypes,
  defaultServiceValuesStepsCurr: (state) => state.defaultServiceValuesStepsCurr,
  defaultServiceValuesStepsTotal: (state) =>
    state.defaultServiceValuesStepsTotal,

  serviceContract: (state) => state.serviceContract,

  showDefaultValuesForm: (state) => state.showDefaultValuesForm,
}

const actions = {
  async createDefaultServiceValues({ commit, dispatch }) {
    commit('setIsLoading', true)
    const params = state.defaultServiceValuesFields

    try {
      await create(params)
      dispatch('showSuccessMessage', Vue.i18n.translate('defaultServiceValues.messages.successfullyCreated'))
      dispatch('fetchDefaultServiceValues')
      commit('setServiceContract', {})
      commit('setShowDefaultValuesForm', false)
      commit('setDefaultServiceSelectedTypes', [])
      commit('setDefaultServiceValuesFields', {
        city_id: '',
        contract_type: '',
        service_contracts: [],
      })
      dispatch
    } catch (error) {
      dispatch('showErrorMessage', Vue.i18n.translate('defaultServiceValues.messages.errorWhileCreating'))
    } finally {
      commit('setIsLoading', false)
    }
  },

  checkSelectedTypes({ commit }) {
    const selectedTypes = []
    const selected = state.defaultServiceValuesFields.service_contracts

    selected.map(({ type }) => selectedTypes.push(type))

    commit(
      'setDefaultServiceSelectedTypes',
      this.getters.serviceTypes.filter((item) => {
        return !selectedTypes.includes(item)
      })
    )
  },
}

const mutations = {
  setDefaultServiceValuesFields: ({ defaultServiceValuesFields }, fields) => {
    state.defaultServiceValuesFields = {
      ...defaultServiceValuesFields,
      ...fields,
    }
  },

  setDefaultServiceSelectedTypes: (state, type) => {
    state.defaultServiceSelectedTypes = type
  },

  setDefaultServiceValuesStepsCurr: (state, step) => {
    state.defaultServiceValuesStepsCurr = step
  },

  setServiceContract: (state, serviceContract) => {
    state.serviceContract = serviceContract
  },

  setShowDefaultValuesForm: (state, status) => {
    state.showDefaultValuesForm = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
